var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import OfferModel from "@/models/loyalty/OfferModel";
import { find, filter, isEmpty } from "lodash";
import AddressModel from "./AddressModel";
import BaseModel from "./BaseModel";
import LoyaltyInfoModel from "./loyalty/LoyaltyInfoModel";
import PaymentAccountModel from "./PaymentAccountModel";
// TODO move Loyalty Info to own Models (still not fully defined)
var CustomerModel = /** @class */ (function (_super) {
    __extends(CustomerModel, _super);
    function CustomerModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.id;
        _this.email = hydrated.email;
        _this.addresses = hydrated.addresses;
        _this.firstName = hydrated.firstName;
        _this.lastName = hydrated.lastName;
        _this.loyaltyInfo = hydrated.loyaltyInfo;
        _this.offers = hydrated.offers;
        _this.paymentAccounts = hydrated.paymentAccounts;
        _this.phone = hydrated.phone;
        _this.pic = hydrated.pic;
        _this.receiveOffers = hydrated.receiveOffers;
        _this.referencePic = hydrated.referencePic;
        _this.__mc = 'CustomerModel';
        return _this;
    }
    CustomerModel.prototype.hydrate = function (data) {
        var customer = {};
        customer.id = data.base || null;
        customer.email = data.email || null;
        customer.addresses = (data.addresses) ? data.addresses.map(function (address) {
            return new AddressModel(address);
        }) : [];
        customer.firstName = data.firstname || "";
        customer.lastName = data.lastname || "";
        if (!data.loyalty_info) {
            customer.loyaltyInfo = null;
        }
        else {
            customer.loyaltyInfo = Object.keys(data.loyalty_info).map(function (locationBase) {
                return new LoyaltyInfoModel(__assign({}, data.loyalty_info[locationBase], { id: locationBase }));
            });
        }
        customer.offers = (data.offers && data.offers.length) ? Object.keys(data.offers).map(function (key) {
            return new OfferModel(data.offers[key]);
        }) : null;
        customer.paymentAccounts = (data.paymentAccounts) ? data.paymentAccounts.map(function (paymentAccount) {
            return new PaymentAccountModel(__assign({}, paymentAccount, { id: paymentAccount.account_id }));
        }) : null;
        customer.phone = data.phone || null;
        customer.receiveOffers = (data.hasOwnProperty("receive_offers")) ? data.receive_offers : false;
        customer.pic = data.pic || null;
        customer.referencePic = data.reference_pic || null;
        return customer;
    };
    CustomerModel.prototype.hydrateFromStore = function (data) {
        var customer = {};
        customer = data;
        return customer;
    };
    CustomerModel.prototype.addOffers = function (offers) {
        var _a;
        (_a = this.offers).push.apply(_a, offers);
    };
    CustomerModel.prototype.getCustomerLoyaltyInfoForStore = function (lb) {
        return find(this.loyaltyInfo, function (loyaltyInfo) {
            return loyaltyInfo.id === lb;
        });
    };
    CustomerModel.prototype.printFullName = function () {
        var first = this.firstName;
        var last = this.lastName;
        var name = "" + first;
        if (!isEmpty(last)) {
            name = name + " " + last;
        }
        return name;
    };
    CustomerModel.prototype.exists = function () {
        var id = this.id;
        return (id) ? true : false;
    };
    // TODO could move this into a payment account model
    CustomerModel.prototype.getDefaultPaymentAccount = function () {
        var paymentAccounts = this.paymentAccounts;
        if (paymentAccounts.length === 0) {
            return null;
        }
        return paymentAccounts[0];
    };
    CustomerModel.prototype.removeAddress = function (addressId) {
        var addresses = this.addresses;
        this.addresses = filter(addresses, function (address) {
            return address.id !== addressId;
        });
    };
    return CustomerModel;
}(BaseModel));
export default CustomerModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/CustomerModel.ts
// module id = null
// module chunks = 